import { REGIONS } from '@/modules/region/domain/region.js';
import { createUpsell } from '@/modules/upsell/domain/upsell.js';

export const i3L3qh = createUpsell({
  id: 'i3L3qh',
  desc: 'Upsell sequence for FitOver40 Wall-Pilates US',
  regions: [REGIONS.us],
  seq: ['upsell-12-month-fo40'],
});
